import { buildCollection, buildProperty } from "@firecms/core";
import type { ContentScopeId } from "../workspace/collectionIds";
import type { UnitProgress } from "../types/participantProgress";
import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";
import type { Locale } from "../localization/constants";

export type { UnitProgress, UnitState } from "../types/participantProgress";

export const buildUnitProgressCollection = (
  contentScopeId: ContentScopeId,
  locale: Locale = getAdminUiLocale()
) => {
  const t = getAdminT(locale);
  void contentScopeId;
  return buildCollection<UnitProgress>({
    name: t("participantProgress.unitProgressCollectionName"),
    singularName: t("participantProgress.unitProgressSingularName"),
    description: t("participantProgress.unitProgressDescription"),
    path: "unitProgress",
    id: "unit_progress",
    icon: "Flag",
    defaultSize: "s",
    selectionEnabled: false,
    permissions: () => ({
      read: true,
      edit: false,
      create: false,
      delete: false,
    }),
    propertiesOrder: [
      "unitCode",
      "state",
      "unlockedAt",
      "startedAt",
      "completedAt",
      "unitId",
    ],
    properties: {
      unitCode: buildProperty({
        name: "Unit",
        dataType: "string",
      }),
      unitId: buildProperty({
        name: "Unit id",
        dataType: "string",
        hideFromCollection: true,
      }),
      state: buildProperty({
        name: "Status",
        dataType: "string",
        enumValues: {
          not_started: "Not started",
          in_progress: "In progress",
          completed: "Completed",
        },
      }),
      unlockedAt: buildProperty({
        name: "Unlocked at",
        dataType: "date",
        mode: "date_time",
      }),
      startedAt: buildProperty({
        name: "Started at",
        dataType: "date",
        mode: "date_time",
      }),
      completedAt: buildProperty({
        name: "Completed at",
        dataType: "date",
        mode: "date_time",
      }),
    },
  });
};
